import React from 'react';
import * as _ from "lodash";
import PageFilterPanel from 'features/pageFilter/PageFilterPanel';
import PageFilterChips from 'features/pageFilter/PageFilterChips';
import Loading from 'common/ui/Loading';
import { BidsPanel } from './BidsPanel';
import { ActionMenuTrigger, LeftDrawerTrigger } from 'features/pageFilter/PageFilterTrigger';
import useDrawer from 'common/ui/useDrawer';
import AddOfferButton from 'features/offers/AddOfferButton';
import useLoader from 'common/ui/useLoader';
import useLocations from 'features/locations/useLocations';
import usePageFilter from 'features/pageFilter/usePageFilter';
import PageFilter from 'features/pageFilter/pageFilter';

const PageName = "bids";
const Bids: React.FC<any> = () => {
    const drawer = useDrawer();
    
    const locations = useLocations();
    const pageFilter = usePageFilter(PageName);
    const loader = useLoader("Bids Page", isLoaded);

    function isLoaded(): boolean {
        return pageFilter.isLoaded;
    }

    function applyFilter(filterParameters: PageFilter) {

        if (filterParameters.locations.length > 0) {
            // Remove commodities not under locations
            const availableCommodities = _.uniqBy(
                filterParameters.locations.flatMap(l => locations.find(m => m.id === l.id).commodities),
                c => c.id);
                filterParameters.commodities = filterParameters.commodities.filter(c => availableCommodities.some(c2 => c2.id === c.id));
        }
        pageFilter.update(filterParameters);
    }

    if (!loader.checkIsLoaded()) return <Loading />;

    return (
        <div className="row no-gutters">
            <div className="col-xs-auto">
                <LeftDrawerTrigger drawerState={drawer} />
                <PageFilterPanel
                    filter={pageFilter.filter}
                    applyFilter={(params: PageFilter) => applyFilter(params)}
                    locations={locations}
                    drawerState={drawer}/>
            </div>
            <div className="col">
                <div className="page-header">
                    Bids
                    <div className="pull-right d-md-none">
                        <ActionMenuTrigger drawerState={drawer} />
                    </div>
                </div>
                
                <div className="row">
                    <div className="col-md-8">
                        <PageFilterChips
                            filter={pageFilter.filter}
                            locations={locations}
                            applyFilter={(params: PageFilter) => applyFilter(params)} />
                    </div>                    
                    <div className="col-md-4 action-bar">
                        <AddOfferButton />
                    </div>
                </div>
                
                <BidsPanel
                    locations={locations}
                    pageFilter={pageFilter.filter}
                    />
            </div>
        </div>
    );
};

export default Bids;